export var WIDGET;
(function (WIDGET) {
    WIDGET["TEXT"] = "TEXT";
    WIDGET["INPUT"] = "INPUT";
    WIDGET["BUTTON"] = "BUTTON";
    WIDGET["SPACE"] = "SPACE";
    WIDGET["ICON"] = "ICON";
    WIDGET["STACK"] = "STACK";
    WIDGET["AVATAR"] = "AVATAR";
    WIDGET["TABS"] = "TABS";
    WIDGET["DIVIDER"] = "DIVIDER";
    WIDGET["CARD"] = "CARD";
    WIDGET["CHATCARD"] = "CHATCARD";
    WIDGET["IMAGE"] = "IMAGE";
    WIDGET["LINKPREVIEW"] = "LINKPREVIEW";
    WIDGET["PROGRESSINDICATOR"] = "PROGRESSINDICATOR";
    WIDGET["LOTTIE"] = "LOTTIE";
    WIDGET["GRADIENT"] = "GRADIENT";
    WIDGET["CHIP"] = "CHIP";
    WIDGET["TAG"] = "TAG";
    WIDGET["MEMBERCARD"] = "MEMBERCARD";
    WIDGET["ICEBREAKERCARD"] = "ICEBREAKERCARD";
    WIDGET["USERCARD"] = "USERCARD";
    WIDGET["NEWSCARD"] = "NEWSCARD";
    WIDGET["DISCUSSIONCARD"] = "DISCUSSIONCARD";
    WIDGET["FEEDCARD"] = "FEEDCARD";
    WIDGET["COMMENTCARD"] = "COMMENTCARD";
    WIDGET["GRID"] = "GRID";
    WIDGET["RADIO"] = "RADIO";
    WIDGET["LINEITEMCARD"] = "LINEITEMCARD";
    WIDGET["MESSAGE"] = "MESSAGE";
    WIDGET["LIST_ITEM"] = "LIST_ITEM";
    WIDGET["HEADER"] = "HEADER";
    WIDGET["SELECTIVE_LIST_ITEM"] = "SELECTIVE_LIST_ITEM";
    WIDGET["VERIFICATIONCARD"] = "VERIFICATIONCARD";
    WIDGET["STEPPER"] = "STEPPER";
    WIDGET["PROMOCARD"] = "PROMOCARD";
    WIDGET["AMOUNTCARD"] = "AMOUNTCARD";
    WIDGET["GRIDITEM"] = "GRIDITEM";
    WIDGET["BOTTOMTAB"] = "BOTTOMTAB";
    WIDGET["REPAYMENT"] = "REPAYMENT";
    WIDGET["INFO"] = "INFO";
    WIDGET["LIST"] = "LIST";
    WIDGET["CTACARD"] = "CTACARD";
    WIDGET["CAMERA"] = "CAMERA";
    WIDGET["GOOGLE_BUTTON"] = "GOOGLE_BUTTON";
    WIDGET["TERMS_TEXT"] = "TERMS_TEXT";
    WIDGET["WEB_VIEW"] = "WEB_VIEW";
    WIDGET["SHIMMERICON"] = "SHIMMERICON";
    WIDGET["ACCORDION"] = "ACCORDION";
    WIDGET["CAROUSAL"] = "CAROUSAL";
    WIDGET["CALENDAR_PICKER"] = "CALENDAR_PICKER";
    WIDGET["DOCUMENT_PICKER"] = "DOCUMENT_PICKER";
    WIDGET["DROPDOWN_INPUT"] = "DROPDOWN_INPUT";
    WIDGET["SUGGESTION_CARD"] = "SUGGESTION_CARD";
    WIDGET["SLIDER"] = "SLIDER";
    WIDGET["BOTTOMSHEET"] = "BOTTOMSHEET";
    WIDGET["LIMIT_CARD"] = "LIMIT_CARD";
    WIDGET["RENDER_WIDGET_GROUP"] = "RENDER_WIDGET_GROUP";
    WIDGET["TABLE"] = "TABLE";
    WIDGET["PROMOTION_CARD"] = "PROMOTION_CARD";
    WIDGET["REWARD_STRUCTURE"] = "REWARD_STRUCTURE";
    WIDGET["KYC_DIGIO_MOBILE"] = "KYC_DIGIO_MOBILE";
    WIDGET["PARTNER_SIGNUP_REFERRER"] = "PARTNER_SIGNUP_REFERRER";
    WIDGET["PARTNER_BENEFIT"] = "PARTNER_BENEFIT";
    WIDGET["VOLT_PARTNERS"] = "VOLT_PARTNERS";
    WIDGET["SELECTION_COMPONENT"] = "SELECTION_COMPONENT";
    WIDGET["CITY_SELECTION_INPUT"] = "CITY_SELECTION_INPUT";
    WIDGET["SCROLL_STACK"] = "SCROLL_STACK";
    WIDGET["ASSET_SEARCH"] = "ASSET_SEARCH";
    WIDGET["PARTNER_DETAILS_CARD"] = "PARTNER_DETAILS_CARD";
    WIDGET["BANK_SELECT_PAGE"] = "BANK_SELECT_PAGE";
    WIDGET["BANK_ADD_PAGE"] = "BANK_ADD_PAGE";
    WIDGET["PARTNER_CHECK_LIMIT_DETAIL_CARD"] = "PARTNER_CHECK_LIMIT_DETAIL_CARD";
    WIDGET["FILTER_CHIP"] = "FILTER_CHIP";
    WIDGET["AUTO_PAY_LANDING_PAGE"] = "AUTO_PAY_LANDING_PAGE";
    WIDGET["KYC_ADDITIONAL_DETAILS_PAGE"] = "KYC_ADDITIONAL_PAGE";
    WIDGET["CO_BORROWER_KYC_ADDITIONAL_DETAILS_PAGE"] = "CO_BORROWER_KYC_ADDITIONAL_PAGE";
    WIDGET["CO_BORROWER_KYC_SUMMARY_PAGE"] = "CO_BORROWER_KYC_SUMMARY_PAGE";
    WIDGET["MANAGE_LIMIT_PAGE"] = "MANAGE_LIMIT_PAGE";
    WIDGET["TRANSACTION_PAGE"] = "TRANSACTION_PAGE";
    WIDGET["TRANSACTION_PAGE_REVAMP"] = "TRANSACTION_PAGE_REVAMP";
    WIDGET["VIEW_PORTFOLIO"] = "VIEW_PORTFOLIO";
    WIDGET["UNPLEDGE_PORTFOLIO"] = "UNPLEDGE_PORTFOLIO";
    WIDGET["APP_BOTTOM_NAV"] = "APP_BOTTOM_NAV";
    WIDGET["EMAIL_STATEMENT_PAGE"] = "EMAIL_STATEMENT_PAGE";
    WIDGET["PARTNER_CUSTOMER_PORTFOLIO_DETAILS"] = "PARTNER_CUSTOMER_PORTFOLIO_DETAILS";
    WIDGET["DIGIO_AGREEMENT_PAGE"] = "DIGIO_AGREEMENT_PAGE";
    WIDGET["CREDIT_LOADING_SCREEN"] = "CREDIT_LOADING_SCREEN";
    WIDGET["APPLICATION_PENDING_BLOCKED_PAGE"] = "APPLICATION_PENDING_BLOCKED_PAGE";
    WIDGET["KFS_PAGE"] = "KFS_PAGE";
    WIDGET["NAME_MISMATCH"] = "NAME_MISMATCH";
    WIDGET["ESIGN_WEBVIEW"] = "ESIGN_WEBVIEW";
    WIDGET["CO_BORROWER_DIGIO_MOBILE"] = "CO_BORROWER_DIGIO_MOBILE";
    WIDGET["LLA_BENEFIT_CARD"] = "LLA_BENEFIT_CARD";
    WIDGET["KYC_DIGIO_CARD"] = "KYC_DIGIO_CARD";
    WIDGET["CUSTOM_HEADER"] = "CUSTOM_HEADER";
    WIDGET["KYC_DIGIO_MANDATE"] = "KYC_DIGIO_MANDATE";
    WIDGET["BORROWER_LANDING_PAGE"] = "BORROWER_LANDING_PAGE";
    WIDGET["BAJAJ_DIGIO_KYC_MODAL"] = "BAJAJ_DIGIO_KYC_MODAL";
    WIDGET["LOGOUT_SCREEN"] = "LOGOUT_SCREEN";
    WIDGET["SUPPORTING_DOCUMENT_PAGE"] = "SUPPORTING_DOCUMENT_PAGE";
    WIDGET["UPLOAD_FILE"] = "UPLOAD_FILE";
    WIDGET["PHOTO_MISMATCH"] = "PHOTO_MISMATCH";
    WIDGET["REWARD_STRUCTURE_WINTER"] = "REWARD_STRUCTURE_WINTER";
    WIDGET["REPAYMENT_PAGE"] = "REPAYMENT_PAGE";
    WIDGET["UPI_IN_PROGRESS"] = "UpiInProgressProps";
    WIDGET["STATE_SELECTION_PAGE"] = "STATE_SELECTION_PAGE";
    WIDGET["FAILURE_PAGE"] = "FAILURE_PAGE";
    WIDGET["PENDING_UNPLEDGE_VIEW"] = "PENDING_UNPLEDGE_VIEW";
    WIDGET["UNPLEDGE_STATUS"] = "UNPLEDGE_STATUS";
    WIDGET["LOAN_FORECLOSURE"] = "LOAN_FORECLOSURE";
    WIDGET["OUTSTANDING_DUES"] = "OUTSTANDING_DUES";
    WIDGET["PENDING_FORECLOSURE"] = "PENDING_FORECLOSURE";
    WIDGET["CO_BORROWER_KYC_VERIFICATION"] = "CO_BORROWER_KYC_VERIFICATION";
    WIDGET["KYC_CARD"] = "KYC_CARD";
    WIDGET["PLEDGE_SCREEN"] = "PLEDGE_SCREEN";
    WIDGET["COLLATERAL_INTRO_SCREEN"] = "COLLATERAL_INTRO_SCREEN";
    WIDGET["PRESENTATION_MATERIAL_SCREEN"] = "PRESENTATION_MATERIAL_SCREEN";
    WIDGET["COLLATERAL_DOWNLOAD_INFO_SCREEN"] = "COLLATERAL_DOWNLOAD_INFO_SCREEN";
    WIDGET["PREVIEW_COLLATERAL_SCREEN"] = "PREVIEW_COLLATERAL_SCREEN";
    WIDGET["COLLATERAL_LANGUAGE_FILTER_SELECT"] = "COLLATERAL_LANGUAGE_FILTER_SELECT";
    WIDGET["USER_CONTEXT_500"] = "USER_CONTEXT_500";
    WIDGET["PAYMENT_NOT_APPROVED"] = "PAYMENT_NOT_APPROVED";
    WIDGET["KYC_SUMMARY"] = "KYC_SUMMARY";
    WIDGET["OTP_MODAL_SCREEN"] = "OTP_MODAL_SCREEN";
    WIDGET["KYC_PHOTO_INIT"] = "KYC_PHOTO_INIT";
    WIDGET["AGREEMENT_INIT"] = "AGREEMENT_INIT";
    WIDGET["AGREEMENT_POLLING"] = "AGREEMENT_POLLING";
    WIDGET["PAN_VIEW_CARD"] = "PAN_VIEW_CARD";
    WIDGET["EMAIL_SUBTITLE"] = "EMAIL_SUBTITLE";
    WIDGET["BAJAJ_AGREEMENT_STEPPER"] = "BAJAJ_AGREEMENT_STEPPER";
    WIDGET["BAJAJ_KFS"] = "BAJAJ_KFS";
    WIDGET["BOTTOM_BAR"] = "BOTTOM_BAR";
    WIDGET["MANAGE_LIMIT_LANDING_PAGE"] = "MANAGE_LIMIT_LANDING_PAGE";
    WIDGET["VERIFY_INTEREST_ENHANCE_LIMIT"] = "VERIFY_INTEREST_ENHANCE_LIMIT";
    WIDGET["PRE_DASHBOARD_SCREEN"] = "PRE_DASHBOARD_SCREEN";
    WIDGET["LOAN_RENEWAL_DASHBOARD_CARD"] = "LOAN_RENEWAL_DASHBOARD_CARD";
    WIDGET["LOAN_RENEWAL_LEARN_MORE_PAGE"] = "LOAN_RENEWAL_LEARN_MORE_PAGE";
    WIDGET["LOAN_RENEWAL_LANDING_PAGE"] = "LOAN_RENEWAL_LANDING_PAGE";
    WIDGET["LOAN_RENEWAL_VERIFY_SUMMARY_PAGE"] = "LOAN_RENEWAL_VERIFY_SUMMARY_PAGE";
    WIDGET["ENHANCE_LIMIT_CARD"] = "ENHANCE_LIMIT_CARD";
    WIDGET["LOAN_RENEWAL_STATUS_PAGE"] = "LOAN_RENEWAL_STATUS_PAGE";
    WIDGET["WITHDRAW_AMOUNT"] = "WITHDRAW_AMOUNT";
    WIDGET["CONFIRM_AMOUNT"] = "CONFIRM_AMOUNT";
    WIDGET["REQUEST_WITHDRAW"] = "REQUEST_WITHDRAW";
    WIDGET["INTEREST_REPAYMENT_CARD"] = "INTEREST_REPAYMENT_CARD";
    WIDGET["LOAN_RENEWAL_EXPIRED_DASHBOARD_CARD"] = "LOAN_RENEWAL_EXPIRED_DASHBOARD_CARD";
    WIDGET["REPAYMENT_CHARGES_DETAILS_PAGE"] = "REPAYMENT_CHARGES_DETAILS_PAGE";
    WIDGET["INTEREST_REPAYMENT_DETAILS"] = "INTEREST_REPAYMENT_DETAILS";
    WIDGET["DEMO_VIDEOS_LIST"] = "DEMO_VIDEOS_LIST";
    WIDGET["PAYMENT_SUCCESSFULL_SCREEN"] = "PAYMENT_SUCCESSFULL_SCREEN";
    WIDGET["FAILURE_NOTE"] = "FAILURE_NOTE";
    WIDGET["DSP_PAYMENT_SCREEN"] = "DSP_PAYMENT_SCREEN";
    WIDGET["INTEREST_REPAYMENT_LEARN_MORE"] = "INTEREST_REPAYMENT_LEARN_MORE";
    WIDGET["RM_CONTACT_LIST"] = "RM_CONTACT_LIST";
    WIDGET["TRACK_FORECLOSURE_REQUEST"] = "TRACK_FORECLOSURE_REQUEST";
    WIDGET["BOTTOM_SHEET_MF"] = "BOTTOM_SHEET_MF";
    WIDGET["FETCH_PORTFOLIO_MODAL"] = "FETCH_PORTFOLIO_MODAL";
    WIDGET["CGTC_INIT"] = "CGTC_INIT";
    WIDGET["CGTC_OTP"] = "CGTC_OTP";
    WIDGET["CGTC_PROGRESS"] = "CGTC_PROGRESS";
    WIDGET["CGTC_SUMMARY"] = "CGTC_SUMMARY";
    WIDGET["CGTC_NO_PORTFOLIO"] = "CGTC_NO_PORTFOLIO";
    WIDGET["REMOVE_PLEDGE_STEPS"] = "REMOVE_PLEDGE_STEPS";
    WIDGET["PLEDGE_HISTORY"] = "PLEDGE_HISTORY";
    WIDGET["PLEDGE_DETAILS"] = "PLEDGE_DETAILS";
    WIDGET["SHORTFALL_CARD"] = "SHORTFALL_CARD";
    WIDGET["SHORTFALL_DETAILS"] = "SHORTFALL_DETAILS";
    WIDGET["SHORTFALL_INFO"] = "SHORTFALL_INFO";
    WIDGET["SHORTFALL_REPAY"] = "SHORTFALL_REPAY";
    WIDGET["SHORTFALL_RECOMENDED_REPAY"] = "SHORTFALL_RECOMENDED_REPAY";
    WIDGET["PHONE_PAY_PAGE"] = "PHONE_PAY_PAGE";
    WIDGET["CREDIT_LIMIT_DOWNLOAD"] = "CREDIT_LIMIT_DOWNLOAD";
    WIDGET["KYC_DIRECT"] = "KYC_DIRECT";
    WIDGET["AS_ES_DOCUMENTS_LISTING"] = "AS_ES_DOCUMENTS_LISTING";
    WIDGET["AS_ES_INDIVIDUAL_DOCUMENT"] = "AS_ES_INDIVIDUAL_DOCUMENT";
    WIDGET["AS_ES_DOCUMENT_UNDER_REVIEW"] = "AS_ES_DOCUMENT_UNDER_REVIEW";
    WIDGET["AS_ES_DOCUMENTS_REJECTED"] = "AS_ES_DOCUMENTS_REJECTED";
    WIDGET["AS_ES_VIEW_SAMPLE_DOCUMENT"] = "AS_ES_VIEW_SAMPLE_DOCUMENT";
    WIDGET["PARTNER_PROMOTION_CARD"] = "PARTNER_PROMOTION_CARD";
    WIDGET["PARTNER_DROP_DOWN_INPUT"] = "PARTNER_DROP_DOWN_INPUT";
    WIDGET["PHONE_NUMBER_PAGE"] = "PHONE_NUMBER_PAGE";
    WIDGET["OTP_VERIFY_PAGE"] = "OTP_VERIFY_PAGE";
    WIDGET["EMAIL_VERIFY_PAGE"] = "EMAIL_VERIFY_PAGE";
    WIDGET["ENTER_EMAIL_PAGE"] = "ENTER_EMAIL_PAGE";
    WIDGET["KYC_PAN_VERIFICATION_PAGE"] = "KYC_PAN_VERIFICATION_PAGE";
    WIDGET["MANAGE_LOAN_DETAILS"] = "MANAGE_LOAN_DETAILS";
    WIDGET["PAYOUT_DASHBOARD_PAGE"] = "PAYOUT_DASHBOARD_PAGE";
    WIDGET["PAYOUT_DETAILS_PAGE"] = "PAYOUT_DETAILS_PAGE";
    WIDGET["IFSC_DETAILS_PAGE"] = "IFSC_DETAILS_PAGE";
    WIDGET["PARTNER_INTEREST_CALCULATOR"] = "PARTNER_INTEREST_CALCULATOR";
    WIDGET["INTEREST_CALCULATOR_WIDGET_APP"] = "INTEREST_CALCULATOR_WIDGET_APP";
    WIDGET["INTEREST_CALCULATOR_ENTRY_CARD"] = "INTEREST_CALCULATOR_ENTRY_CARD";
    WIDGET["CUSTOMER_DETAILS_TABLE"] = "CUSTOMER_DETAILS_TABLE";
    WIDGET["INTEREST_FILTER_SCREEN_DC"] = "INTEREST_FILTER_SCREEN_DC";
    WIDGET["CUSTOMER_VIEW_DETAILS_SCREEN_DC"] = "CUSTOMER_VIEW_DETAILS_SCREEN_DC";
    WIDGET["CUSTOMER_FILTER_SCREEN_DC"] = "CUSTOMER_FILTER_SCREEN_DC";
    WIDGET["RENEWAL_FILTER_SCREEN_DC"] = "RENEWAL_FILTER_SCREEN_DC";
    WIDGET["SHORTFALL_FILTER_SCREEN_DC"] = "SHORTFALL_FILTER_SCREEN_DC";
    WIDGET["CUSTOMER_MOB_DETAILS"] = "CUSTOMER_MOB_DETAILS";
    WIDGET["PARTNER_REGISTER_LEADS"] = "PARTNER_REGISTER_LEADS";
    WIDGET["PARTNER_LEADS_REGISTRATION_SUCCESS"] = "PARTNER_LEADS_REGISTRATION_SUCCESS";
    WIDGET["PLJ_JOURNEY_PAGE"] = "PLJ_JOURNEY_PAGE";
    WIDGET["WITHDRAWAL_FAILED_CARD"] = "WITHDRAWAL_FAILED_CARD";
    WIDGET["VERIFY_AND_INTEREST_SCREEN"] = "VERIFY_AND_INTEREST_SCREEN";
    WIDGET["SDK_PROCESS_COMPLETE_CARD"] = "SDK_PROCESS_COMPLETE_CARD";
    WIDGET["PENDING_APPLICATION_SCREEN"] = "PENDING_APPLICATION_SCREEN";
    WIDGET["PENDING_MOBILE_APPLICATION_SCREEN"] = "PENDING_MOBILE_APPLICATION_SCREEN";
    WIDGET["PENDING_CUSTOMER_VIEW_DETAILS_SCREEN_DC"] = "PENDING_CUSTOMER_VIEW_DETAILS_SCREEN_DC";
    WIDGET["ABOUT_US_SCREEN_DC"] = "ABOUT_US_SCREEN_DC";
    WIDGET["LENDING_PARTNER_SCREEN_DC"] = "LENDING_PARTNER_SCREEN_DC";
    WIDGET["PRODUCT_DETAILS_SCREEN_DC"] = "PRODUCT_DETAILS_SCREEN_DC";
    WIDGET["DSP_KFS_PAGE"] = "DSP_KFS_PAGE";
    WIDGET["CONTACT_US_PAGE"] = "CONTACT_US_PAGE";
    WIDGET["REPAYMENT_BANK_TRANSFER"] = "REPAYMENT_BANK_TRANSFER";
    WIDGET["ACCOUNT_DETAILS_PAGE"] = "ACCOUNT_DETAILS_PAGE";
    WIDGET["FAQ_SECTION_PAGE"] = "FAQ_SECTION_PAGE";
    WIDGET["MFC_FETCH_EVALUATE_FUNDS"] = "MFC_FETCH_EVALUATE_FUNDS";
    WIDGET["MFC_FETCH_LANDING_PAGE"] = "MFC_FETCH_LANDING_PAGE";
    WIDGET["MFC_FETCH_ANCHOR"] = "MFC_FETCH_ANCHOR";
    WIDGET["RECOMMENDED_ASSET_REPOSITORY"] = "RECOMMENDED_ASSET_REPOSITORY";
    WIDGET["MY_LOAN_PROFILE"] = "MY_LOAN_PROFILE";
    WIDGET["UPDATE_LOGIN_SCREEN"] = "UPDATE_LOGIN_SCREEN";
    WIDGET["UPDATE_EMAIL_SCREEN"] = "UPDATE_EMAIL_SCREEN";
    WIDGET["UPDATE_DETAILS_SCREEN"] = "UPDATE_DETAILS_SCREEN";
    WIDGET["CONFIRM_AND_PAYMENT"] = "CONFIRM_AND_PAYMENT";
    WIDGET["FLEXI_REPAY"] = "FLEXI_REPAY";
    WIDGET["MFD_SHARE_LINK_INIT_PAGE"] = "MFD_SHARE_LINK_INIT_PAGE";
    WIDGET["FORECLOSURE_NEW_SCREEN"] = "FORECLOSURE_NEW_SCREEN";
    WIDGET["FORECLOSURE_REASON_SCREEN"] = "FORECLOSURE_REASON_SCREEN";
    WIDGET["CONFIRM_LOAN_DETAILS"] = "CONFIRM_LOAN_DETAILS";
    WIDGET["FORECLOSURE_COLLATERAL_DETAILS"] = "FORECLOSURE_COLLATERAL_DETAILS";
    WIDGET["FORECLOSURE_STATUS_PAGE"] = "FORECLOSURE_STATUS_PAGE";
    WIDGET["ELEVATE_LANDING"] = "ELEVATE_LANDING";
    WIDGET["ELEVATE_HOME_CARD"] = "ELEVATE_HOME_CARD";
    WIDGET["ELEVATE_CONTINUE_CARD"] = "ELEVATE_CONTINUE_CARD";
    WIDGET["ELEVATE_HEADER"] = "ELEVATE_HEADER";
    WIDGET["ELEVATE_SWITCHING"] = "ELEVATE_SWITCHING";
})(WIDGET || (WIDGET = {}));
